import { useEffect, useRef, useState } from "react";
import { Check, Eraser, Eye, Loader2, RotateCcw, X } from "lucide-react";

const crop = (c) => {
  const { data, width, height } = c.getContext("2d").getImageData(0, 0, c.width, c.height);
  let x0 = width, y0 = height, x1 = -1, y1 = -1;
  for (let y = 0; y < height; y += 2) for (let x = 0; x < width; x += 2) if (data[(y * width + x) * 4 + 3]) { x0 = Math.min(x0, x); y0 = Math.min(y0, y); x1 = Math.max(x1, x); y1 = Math.max(y1, y); }
  if (x1 < 0) return "";
  const p = 12; const w = Math.min(width, x1 + p) - Math.max(0, x0 - p); const h = Math.min(height, y1 + p) - Math.max(0, y0 - p);
  const o = document.createElement("canvas"); o.width = w; o.height = h;
  o.getContext("2d").drawImage(c, Math.max(0, x0 - p), Math.max(0, y0 - p), w, h, 0, 0, w, h);
  return o.toDataURL("image/png");
};

export default function BFSignPad({ title, onSave, onCancel, busy, testid = "bf-signpad" }) {
  const ref = useRef(null);
  const last = useRef(null);
  const [has, setHas] = useState(false);
  const [prev, setPrev] = useState("");
  const size = () => { const c = ref.current; c.width = Math.round(c.offsetWidth * 2); c.height = Math.round(c.offsetHeight * 2); };
  useEffect(size, []);
  const pt = (e) => { const r = ref.current.getBoundingClientRect(); return [(e.clientX - r.left) / r.width, (e.clientY - r.top) / r.height]; };
  const down = (e) => {
    e.preventDefault();
    const c = ref.current;
    if (!has && (c.width !== Math.round(c.offsetWidth * 2) || c.height !== Math.round(c.offsetHeight * 2))) size();
    c.setPointerCapture(e.pointerId); last.current = pt(e);
  };
  const move = (e) => {
    if (!last.current) return;
    const c = ref.current; const ctx = c.getContext("2d"); const p = pt(e);
    ctx.lineWidth = 6; ctx.lineCap = "round"; ctx.lineJoin = "round"; ctx.strokeStyle = "#0b1f5c";
    ctx.beginPath(); ctx.moveTo(last.current[0] * c.width, last.current[1] * c.height); ctx.lineTo(p[0] * c.width, p[1] * c.height); ctx.stroke();
    last.current = p; setHas(true);
  };
  const up = () => { last.current = null; };
  const clear = () => { const c = ref.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); setHas(false); setPrev(""); };
  return (
    <div className="bf-signpad" data-testid={testid}>
      <p className="bf-signpad-title">{title}</p>
      <canvas ref={ref} className={prev ? "is-hidden" : ""} onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerCancel={up} data-testid={`${testid}-canvas`} />
      {prev ? (
        <>
          <div className="bf-signpad-prev" data-testid={`${testid}-preview`}><img src={prev} alt="Previzualizare semnătură" /><span>Așa apare semnătura în contract</span></div>
          <div className="share-actions">
            <button type="button" className="st-btn st-btn--silver" disabled={busy} onClick={() => onSave(ref.current.toDataURL("image/png"))} data-testid={`${testid}-save`}>
              {busy ? <Loader2 size={14} className="animate-spin" /> : <Check size={14} />} Confirm și semnez
            </button>
            <button type="button" className="st-btn st-btn--ghost" disabled={busy} onClick={clear} data-testid={`${testid}-redo`}><RotateCcw size={14} /> Refac semnătura</button>
          </div>
        </>
      ) : (
        <>
          <span className="bf-signpad-line">Semnați cu degetul în chenarul de mai sus</span>
          <div className="share-actions">
            <button type="button" className="st-btn st-btn--silver" disabled={!has || busy} onClick={() => setPrev(crop(ref.current))} data-testid={`${testid}-preview-btn`}><Eye size={14} /> Vezi semnătura</button>
            <button type="button" className="st-btn st-btn--ghost" disabled={busy} onClick={clear} data-testid={`${testid}-clear`}><Eraser size={14} /> Șterge</button>
            {onCancel && <button type="button" className="st-btn st-btn--ghost" disabled={busy} onClick={onCancel} data-testid={`${testid}-cancel`}><X size={14} /> Renunță</button>}
          </div>
        </>
      )}
    </div>
  );
}
